import React, { useContext } from "react";

const ModalContext = React.createContext({ isModal: false });

const ModalProvider = ({ isModal, children }) => (
  <ModalContext.Provider value={{ isModal }}>{children}</ModalContext.Provider>
);

const useIsModal = () => {
  const context = useContext(ModalContext);

  return context.isModal;
};

export { ModalProvider, useIsModal };
